export default function PendingIcon() {
  return (
    <svg
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.8971 11.25L9 9V4.5M14.2657 6.34838H18.0157M18.0157 6.34838V2.59838M18.0157 6.34838L14.8336 3.16637C13.6798 2.01259 12.2098 1.22685 10.6095 0.908525C9.00915 0.590197 7.35035 0.753575 5.84286 1.378C4.33537 2.00242 3.0469 3.05984 2.14038 4.41655C1.23385 5.77326 0.75 7.36831 0.75 9C0.75 10.6317 1.23385 12.2268 2.14038 13.5835C3.0469 14.9402 4.33537 15.9976 5.84286 16.622C7.35035 17.2464 9.00915 17.4098 10.6095 17.0915C12.2098 16.7732 13.6798 15.9874 14.8336 14.8336"
        stroke="#B721FF"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
